import useAuth from '@app/auth/use-auth';
import { Tab } from '@shared/components/page-tabs';
import { pcfRoutes } from '../pcf-routes';

export function useProductComponentTabs(): Tab[] {
  const { user } = useAuth();
  const { features, productCategory } = user!;
  const productClient = productCategory === 'product';

  return [
    {
      title: 'Ingredients',
      href: pcfRoutes.PRODUCT_COMPONENTS_INGREDIENTS,
    },
    {
      title: 'Processing',
      href: pcfRoutes.PRODUCT_COMPONENTS_PROCESSING,
      hide: !features.pcf || !productClient,
    },
    {
      title: 'Packaging',
      href: pcfRoutes.PRODUCT_COMPONENTS_PACKAGING,
      hide: !features.pcf,
    },
    {
      title: 'Transport',
      href: pcfRoutes.PRODUCT_COMPONENTS_TRANSPORT,
      hide: !features.pcf || !productClient,
    },
  ];
}
